import React from 'react'

import { formatAudioTime } from '@/helpers/music'

export interface DurationProps {
  value?: number | null
  loading?: boolean
  className?: string
  negative?: boolean
}

const Duration: React.FC<DurationProps> = (props) => {
  const { loading, value, className, negative } = props

  if (loading) {
    return (
      <CssIcon
        className={tw`
          i-cus--tad-loading animate-spin
          ${className}
        `}
      />
    )
  }
  return (
    <span
      className={className}
    >{`${negative ? '-' : ''}${formatAudioTime(value ?? 0)}`}</span>
  )
}

export default Duration
